import src from "IMAGE";
export default { src, width: 432, height: 200, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAS0lEQVR42k3MOwqAMBBF0VeJ1pY2fhCxFFxFAiEhkP0vJXdgihSHx8BlJCkgYsXiZt8Jqmh48eEfbBYkZOy48Xhse1hQ/IMdJ65RB1ltBX19jMdEAAAAAElFTkSuQmCC"};
